module.exports = __webpack_public_path__ + "static/media/sync.a22f2be8.svg";